import { useEffect, useState } from 'react';
import { KeyRound } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from './ui/dialog';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { onAdminKeyRequest } from '../lib/adminKey';

export const AdminKeyDialog = () => {
  const [resolver, setResolver] = useState(null);
  const [value, setValue] = useState('');

  useEffect(() => onAdminKeyRequest((resolve) => setResolver(() => resolve)), []);

  const close = (key) => {
    resolver?.(key);
    setResolver(null);
    setValue('');
  };

  return (
    <Dialog open={!!resolver} onOpenChange={(open) => !open && close(null)}>
      <DialogContent data-testid="admin-key-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound className="h-4 w-4 text-primary" /> Admin key required
          </DialogTitle>
          <DialogDescription>
            This action changes saved data. Enter your admin key — it is kept only for this browser tab.
          </DialogDescription>
        </DialogHeader>
        <form
          className="space-y-4"
          onSubmit={(ev) => { ev.preventDefault(); if (value.trim()) close(value.trim()); }}
        >
          <Input
            type="password" autoComplete="off" autoFocus placeholder="Admin key"
            value={value} onChange={(ev) => setValue(ev.target.value)}
            data-testid="admin-key-input"
          />
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => close(null)} data-testid="admin-key-cancel-btn">
              Cancel
            </Button>
            <Button type="submit" disabled={!value.trim()} data-testid="admin-key-submit-btn">
              Unlock
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
